import { render, staticRenderFns } from "./ScadenzeOggi.vue?vue&type=template&id=241e014e"
import script from "./ScadenzeOggi.vue?vue&type=script&lang=js"
export * from "./ScadenzeOggi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports